import { baseUrlUsers as users } from "lib/actions/endpoints/endpoints";
import { Endpoint } from "lib/types/Endpoint";

export const endpointsMembers = {
  projectMembers: (id: number) => `${users}/project/${id}`,
  projectInvites: (id: number) => `${users}/invite/project/${id}`,
  projectPermissions: (id: number, userId: string) =>
    ({
      method: "PUT",
      url: `${users}/project/${id}/user/${userId}/permissions`,
    }) as Endpoint,
  projectInvite: (id: number) =>
    ({
      method: "POST",
      url: `${users}/invite/project/${id}`,
    }) as Endpoint,
  workspaceLimits: (id: number) => `${users}/workspace/${id}/limits`,
  inviteRevoke: (id: string) =>
    ({
      method: "DELETE",
      url: `${users}/invite/${id}`,
    }) as Endpoint,
  accountCreate: { method: "POST", url: `${users}/Account` } as Endpoint,
  emailConfirmationSend: {
    method: "POST",
    url: `${users}/Account/emailconfirmation/send`,
  } as Endpoint,
  emailConfirmationConfirm: {
    method: "PUT",
    url: `${users}/Account/emailconfirmation/confirm`,
  } as Endpoint,
  updateMember: (id: string) =>
    ({
      method: "PUT",
      url: `${users}/${id}`,
    }) as Endpoint,
};
